
























helpers = require('../../helpers.coffee')

view_model = {
  data: ->
    current_user: Session.current_user
  props:
    flow:
      required: true

    action:
      required: true

    contact:
      required: true

  computed:
    specific_template: ->
      @action.contact_specific_templates.find (template) =>
        template.belongsToContact(@contact) && !template._destroy

    edited: ->
      @specific_template && Object.keys(@specific_template).length > 0

    template: ->
      template = Object.assign({}, @action.template)
      if @specific_template
        template.subject = @specific_template.subject
        template.body = @specific_template.body
        template.signature = @specific_template.signature
      template

  methods:
    editSpecificTemplate: (event, attr = {}) ->
      event.originalEventName = 'specific-template-edit'
      @$emit 'specific-template-edit', { event, @action }

    destroySpecificTemplate: (event, attr = {}) ->
      event.originalEventName = 'specific-template-destroy'
      @$emit 'specific-template-destroy', { event, @action }
}

exports.default = view_model




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/specific_templates/list_item.vue